module.exports = __webpack_public_path__ + "img/banner-15.e4ec5333.jpg";